@if (tags() && custome() && formGroup()) {
<div class="content">
    @for (tag of tags(); track tag.key) {
    <app-expansion [status]="custome()[tag.key]" [meta]="{title: tag.key}">
        @for (field of tag.value; track field.meta.id) {
        <app-content-field [formGroup]="formGroup()!" [field]="field" [node]="$any(node())" [readonly]="readonly()"></app-content-field>
        }
    </app-expansion>
    }
</div>
}
